import TableItemRow from './tableItemRow.js';
import events from './event.js';
import { textString } from './texts.js';
import _ from './translate.js';
import Storage from './storage.js';
import Logger from './logger.js';

class Table {
    terms = [];
    items = [];
    wrapperDiv = null;
    options = {};

    constructor(options) {
        this.options = options;
        if (options?.wrapperDiv === undefined) {
            Logger.error('Table failed to initialize.');
            return;
        }
        this.wrapperDiv = options.wrapperDiv;
        this.wrapperDiv.classList.add('mscp-table');
        this.createItems();
    }
    async createItems() {
        this.options.terms?.forEach(term => {
            const itemRow = new TableItemRow(
                { ...this.options, term },
            );
            this.items.push(itemRow);
            this.wrapperDiv.appendChild(itemRow.rowDiv);
        });
        this.actionIfNoItemsVisible();
    }

    async updateVisibleItems(visibleItems) {
        // Update the visibility of items based on the provided array
        // and sync selected state with Storage
        const storedValue = Storage.get(this.options.type);
        this.items.forEach(item => {
            const value = item.rowDiv.getAttribute('data-value');
            const isVisible = visibleItems.includes(value) || visibleItems.includes(Number(value));

            if (isVisible) {
                item.rowDiv.classList.remove('hidden');
            } else {
                item.rowDiv.classList.add('hidden');
            }

            // Synka selected-klass med Storage så att visuellt state matchar faktiskt state
            item.rowDiv.classList.toggle('selected', isVisible && !!storedValue && value == storedValue);
        });
        this.actionIfNoItemsVisible();
        this.updatePostCreateCallbacks();
    }

    async selectItemByValue(value) {
        if (value === undefined || value === null) {
            return;
        }
        this.deselectAll();
        const itemToSelect = this.items.find(item => item.rowDiv.getAttribute('data-value') == value);
        if (itemToSelect && !itemToSelect.rowDiv.classList.contains('hidden')) {
            itemToSelect.rowDiv.classList.add('selected');
            Storage.save(this.options.type, itemToSelect.rowDiv.getAttribute('data-value')); // Save the selected item in storage
            events.trigger('updateNavigation'); // Trigger navigation update
        } else {
            Storage.save(this.options.type, ''); // Clear the selected item in storage
            events.trigger('updateNavigation'); // Trigger navigation update
        }
    }
    // selectFirstVisibleItem() {
    //     let selectedItem = this.wrapperDiv.querySelector('.mscp-item.selected');
    //     if (!selectedItem) {
    //         selectedItem = this.wrapperDiv.querySelector('.mscp-item:not(.hidden)');
    //         if (selectedItem) {
    //             selectedItem.classList.add('selected');
    //             Storage.save(this.options.type, selectedItem.getAttribute('data-value')); // Save the selected item in storage
    //         }
    //     }
    //     events.trigger('updateNavigation'); // Trigger navigation update

    //     // run callback
    //     this.options.postInitSelectedItemsCallback?.(selectedItem);
    // }

    actionIfNoItemsVisible() {
        const visibleItems = this.wrapperDiv.querySelectorAll('.mscp-item:not(.hidden)');
        this.wrapperDiv.querySelector('.mscp-no-items')?.remove(); //cleanup old messages

        if (visibleItems.length === 0) {
            const noItemsMessage = document.createElement('div');
            noItemsMessage.classList.add('mscp-no-items');
            noItemsMessage.innerHTML = textString('no_items_available', _("No items available for this presentation."));
            this.wrapperDiv.appendChild(noItemsMessage);
            Storage.save(this.options.type, ''); // Clear the selected type in storage
            events.trigger('updateNavigation'); // Trigger navigation update
        }
        // else if (visibleItems.length === 1) {
        //     // If only one item is visible, select it automatically
        //     const firstVisibleItem = visibleItems[0];
        //     firstVisibleItem.classList.add('selected');
        //     Storage.save(this.options.type, firstVisibleItem.getAttribute('data-value')); // Save the selected item in storage
        //     events.trigger('updateNavigation'); // Trigger navigation update
        // }
        else {
            // if selected item is not visible, remove the selected class
            const selectedHiddenItem = this.wrapperDiv.querySelector('.mscp-item.selected.hidden');
            if (selectedHiddenItem) {
                selectedHiddenItem.classList.remove('selected');
                Storage.save(this.options.type, ''); // Clear the selected paper in storage
                setTimeout(() => {
                    events.trigger('updateNavigation'); // Trigger navigation update
                }, 100);
            }
            const noItemsMessage = this.wrapperDiv.querySelector('.mscp-no-items');
            if (noItemsMessage) {
                noItemsMessage.remove();
            }
        }
    }
    updatePostCreateCallbacks() {
        this.items.forEach(async (item) => {
            if (this.options.postCreateTitleCallback) {
                const existingCallbackElements = item.rowDiv.querySelectorAll('.mscp-post-create');
                existingCallbackElements.forEach(el => el.remove());

                const callbackElement = await this.options.postCreateTitleCallback(item.options.term);
                if (Array.isArray(callbackElement)) {
                    callbackElement.forEach(el => {
                        item.rowDiv.querySelector('.mscp-item-title')?.parentElement?.appendChild(el);
                    });
                }
                else if (callbackElement) {
                    item.rowDiv.querySelector('.mscp-item-title')?.parentElement?.appendChild(callbackElement);
                }
            }
        });
    }
    /**
     * Select an item exactly as a user click would (validation, storage, selectCallback).
     * Returns false when the value is unknown or hidden, so a bad deep link is a no-op.
     */
    clickItemByValue(value) {
        if (value === undefined || value === null || value === '') return false;
        const item = this.items.find(i => i.rowDiv.getAttribute('data-value') == value);
        if (!item || item.rowDiv.classList.contains('hidden')) return false;
        item.rowDiv.click();
        return true;
    }
    deselectAll() {
        this.items.forEach(item => {
            item.rowDiv.classList.remove('selected');
        });
    }
}

export default Table;